import JobPosting from '@root/careers/src/models/job-posting';
import getJobPostingsFromWorkdayConfiguration from '@root/careers/src/api/get-job-postings-from-workday';
import useNetworkRequest from '@root/core/src/hooks/use-network-request';
import { useCallback, useState } from '@root/vendor/react';

const configuration = getJobPostingsFromWorkdayConfiguration();

const hasRequiredFields = (jobPosting) => {
  return !!(jobPosting.jobDescription &&
    jobPosting.jobPosting &&
    jobPosting.id &&
    jobPosting.primaryLocation &&
    jobPosting.team &&
    jobPosting.applyURL)
  ;
};

export default function useJobPostingsFromWorkday({ team = null } = {}) {
  const [jobPostings, setJobPostings] = useState([]);
  const isLoading = useNetworkRequest(configuration, useCallback((result) => {
    setJobPostings(
      (result?.data || [])
        .filter((jobPosting) =>
          hasRequiredFields(jobPosting) &&
          (!team || jobPosting.team.toLowerCase() === team.toLowerCase())
        )
        .map((jobPosting) => JobPosting.createWorkdayJobPosting(jobPosting))
    );
  }, [team]));

  return [isLoading, jobPostings];
}
